import { requestedDocsAtom, userAtom } from "../../../shared/atoms";
import Checkbox from "../../../shared/components/Checkbox";
import { DocTypesCheckboxesProps } from "../../models/document-request.models";
import { useAtom, useAtomValue } from "jotai";

const DocTypesCheckboxes: React.FC<DocTypesCheckboxesProps> = ({ docTypes }) => {
  const [requestedDocs, setDocumentsRequested] = useAtom(requestedDocsAtom);
  const user = useAtomValue(userAtom);

  return (
    <>
      {docTypes.map((docType) => {
        const hasDocumentAlready = requestedDocs.some((doc) => doc.name === docType.name);
        const handleChange = () => {
          if (hasDocumentAlready) {
            setDocumentsRequested((docs) => docs.filter((doc) => doc.name !== docType.name));
          } else {
            setDocumentsRequested((docs) => [
              ...docs,
              { name: docType.name, docType: docType.docType, requestedBy: user?.email },
            ]);
          }
        };

        return (
          <Checkbox
            key={docType.name}
            name={`request-document-${docType.template}`}
            checked={hasDocumentAlready}
            label={docType.name}
            onChange={handleChange}
          />
        );
      })}
    </>
  );
};

export default DocTypesCheckboxes;
